import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>Renshinkan Dojo Chiang Mai's Classes</h3>

      <br />
      <br />


        <div><Link to='/rosterchiangmai'>Tuesday 17.30-18.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Tuesday 18.30-20.00</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Wednesday 8.00-9.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Thursday 17.30-18.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Thursday 18.30-20.00</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Friday 8.00-9.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Saturday 8.00-9.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Saturday 9.45-12.00</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Sunday 8.00-9.30</Link></div>
        <br />
        <div><Link to='/rosterchiangmai'>Sunday 9.45-12.00</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
